import {AbstractChannel, MAIL_CHANNEL} from "@/services/boostpack/channel/abstract_channel.type";

export class MailChannel extends AbstractChannel {


	getChannelType(): string {
		return MAIL_CHANNEL;
	}

}